module.exports = __webpack_public_path__ + "static/media/SANDDOLAR.19777cbe.jpg";